export const autoDebitSyncFnReducers = {
  updateCurrentScreen: (state, action) => {
    state.currentScreen = action.payload;
  },
  toggleRightSidebar: (state, action) => {
    const { showRightSidebar } = action.payload;
    state.showRightSidebar = showRightSidebar;
  },
  toggleUploadNACHFormBtnClicked: (state, action) => {
    const { uploadNACHFormBtnClicked } = action.payload;
    state.uploadNACHFormBtnClicked = uploadNACHFormBtnClicked;
  },
  toggleShowWelcomeScreen: (state, action) => {
    state.adShowWelcomeScreen = action.payload;
  },
  toggleShowBankDetailsScreen: (state, action) => {
    state.adShowBankDetailsScreen = action.payload;
  },
  updateAckScreenData: (state, action) => {
    state.ackScreen = { ...action.payload };
  },
  toggleGlobalOverlayLoader: (state, action) => {
    state.globalOverlayLoader = action.payload;
  },
  updatePreviousScreen: (state, action) => {
    state.previousScreen = action.payload;
  },
  toggleNachUploadMethodButton: (state, action) => {
    state.nachMethodButtonSelected = action.payload;
  },
  toggleAddtionalDocsSorryScreen: (state, action) => {
    state.adShowSorryForTroubleScreen = action.payload;
  },
  toggleSkipAdOnlineThreeChoicesScreen: (state, action) => {
    state.skipAdOnlineThreeChoicesScreen = action.payload;
  },
  toggleCustomerComingFromSSOJourney: (state, action) => {
    state.adCustomerComingFromSSOjourney = action.payload;
  },
  toggleIsEligibleForEmandateCancellation: (state, action) => {
    state.isEligibleForEmandateCancellation = action.payload;
  },
};
